export enum GuardianType {
  Guardian = "Guardian",
  UAC = "UAC",
}

export type GuardianSettings = {
  accountIds?: string[]
  safeId?: string
  about?: {
    title?: string
    content?: string
    learnMoreUrl?: string
  }
  type: GuardianType
}

// Hardcoded list of Prganizations with Guardians  settings
const GUARDIAN_ORG_SETTINGS: Record<
  string,
  Record<string, GuardianSettings>
> = {
  "https://api.tally.xyz": {
    // Uniswap: https://www.tally.xyz/gov/uniswap
    "2206072050458560434": {
      accountIds: [
        "eip155:1:0xE063605aC63eDfB2426F0Cb83958b8989A57Df6B",
        "eip155:1:0x10CD96549C0D7C43d4C017D32843ceCa41cc1B4a",
        "eip155:1:0x26C4b264f87622F3ef09Fe5AD0e0Ea081bCfdC0b",
        "eip155:1:0x3d0e30031b547737fFCf13c127350159A6C4ce17",
        "eip155:1:0xB8Dcad009E533066F12e408075E10E3a30F1f15A",
      ],
      type: GuardianType.UAC,
      about: {
        title: "What is UAC?",
        content:
          "The Uniswap Accountability Committee (UAC) is a group of community-elected signers responsible for executing passed governance proposals and maintaining routine protocol operations. The UAC ensures Uniswap's governance decisions are implemented efficiently while preserving the decentralized nature of the ecosystem.",
      },
    },

    // zksync: https://www.tally.xyz/gov/zksync
    "2297436623035434412": {
      accountIds: [
        "eip155:1:0x55c671BcE13120387Ded710A1d1b80C0e3d8E857",
        "eip155:1:0xCe7a3dFcc35602155809920Ff65e093aa726f6cf",
        "eip155:1:0x6D26874130A174839b9cd8CB87Ed4E09D0c1a5f0",
        "eip155:1:0x015318c16AE443a20DE0A776dB06a59F0D279057",
        "eip155:1:0x178D8Eb1A1fb81B5102808A83318Bb04C6a9fC6D",
        "eip155:1:0x2A90830083C5Ca1f18d7AA7fCDC2998f93475384",
        "eip155:1:0x590926dBCDfD19627c3BbD2A6Eb96DeC7a3AbF69",
        "eip155:1:0x538612F6eba6ff80FBD95D60dCDee16b8FfF2c0f",
      ],
      type: GuardianType.Guardian,
      about: {
        title: "What are Guardians?",
        content:
          "Guardians create proposals in ZKsync. They are selected by the core team.",
        learnMoreUrl:
          "https://docs.zknation.io/zksync-governance/schedule-4-zksync-guardians",
      },
    },

    // Codename-testnet (zkSync): https://www.tally.xyz/gov/codename-testnet
    "2333649329245390000": {
      accountIds: [
        "eip155:1:0x4d1E3089042Ab3A93E03CA88B566b99Bd22438C6",
        "eip155:1:0x227230CD05e89f41E67df3E5fC61B18411d147A9",
        "eip155:1:0xb799FF3DeF706045B5061B22d748E8F52737415d",
        "eip155:1:0x8b0c64CcaB94d4618Ef834F396F622f61F2b013D",
        "eip155:1:0x0e621b0A275A207211e161Ee997aA80661Bc1bcf",
        "eip155:1:0x160669864cDe95c190364ad01eDfbAA32E9DA430",
        "eip155:1:0x3620B9e7c75E09cCC37458c7B6EE6c23D8Ee4f0f",
        "eip155:1:0xa376AaF645dbd9b4f501B2A8a97bc21DcA15B001",
      ],
      type: GuardianType.Guardian,
      about: {
        title: "What are Guardians?",
        content:
          "Guardians create proposals in ZKsync. They are selected by the core team.",
        learnMoreUrl:
          "https://docs.zknation.io/zksync-governance/schedule-4-zksync-guardians",
      },
    },

    // testnet-zksync: https://www.tally.xyz/gov/testnet-zksync
    "2383575338992010920": {
      accountIds: [
        "eip155:1:0x4d1E3089042Ab3A93E03CA88B566b99Bd22438C6",
        "eip155:1:0x227230CD05e89f41E67df3E5fC61B18411d147A9",
        "eip155:1:0xb799FF3DeF706045B5061B22d748E8F52737415d",
        "eip155:1:0x8b0c64CcaB94d4618Ef834F396F622f61F2b013D",
        "eip155:1:0x0e621b0A275A207211e161Ee997aA80661Bc1bcf",
        "eip155:1:0x160669864cDe95c190364ad01eDfbAA32E9DA430",
        "eip155:1:0x3620B9e7c75E09cCC37458c7B6EE6c23D8Ee4f0f",
        "eip155:1:0xa376AaF645dbd9b4f501B2A8a97bc21DcA15B001",
      ],
      type: GuardianType.Guardian,
      about: {
        title: "What are Guardians?",
        content:
          "Guardians create proposals in ZKsync. They are selected by the core team.",
        learnMoreUrl:
          "https://docs.zknation.io/zksync-governance/schedule-4-zksync-guardians",
      },
    },
  },

  "https://api.staging.tally.xyz": {
    // Compound: https://staging.tally.xyz/gov/compound-39
    "2206056275966428570": {
      safeId: "eip155:42161:0x3568A44b3E72F5B17a0E14E53fdB7366B3B7Ad13",
      type: GuardianType.Guardian,
      about: {
        title: "What are Guardians?",
        content:
          "Guardians create proposals in ZKsync. They are selected by the core team.",
        learnMoreUrl: "https://zksync.io/ethos",
      },
    },
  },
}

export const getGuardianOrganizationSettings = (organizationId: string) => {
  return GUARDIAN_ORG_SETTINGS?.[process.env.NEXT_PUBLIC_TALLY_API_URL]?.[
    organizationId
  ]
}
